export const regexPatterns = {
  email: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,20}$/,
  phoneNumber: /^[0-9]{9,15}$/,
};

export const mobileApp = {
  android: 'https://play.google.com/store/apps/details?id=com.unifiproperty.client',
  ios: 'https://apps.apple.com/au/app/unifi-property/id6648757132'
}



// WEBPACK FOOTER //
// ./src/components/utils/utils.js